import React from "react";
import { citationTitle } from "../../../../helpers/utils/citation-utils";

/**
 * An inline [n]: a superscript that opens source n under the answer.
 *
 * Shared by every renderer that shows answer text, so a citation works
 * wherever the reply lands (a text bubble, a cards intro, a card description).
 */
export default function CitationRef({ number, source, onCitationClick }) {
  const title = citationTitle(source);
  return (
    <sup className="chat-citation">
      <button
        type="button"
        className="chat-citation-ref"
        onClick={() => onCitationClick && onCitationClick(number)}
        title={title}
        aria-label={`Source ${number}: ${title || ""}`}
      >
        [{number}]
      </button>
    </sup>
  );
}

/** The answer's sources, from a message's metadata. */
export function sourcesOf(metadata) {
  return Array.isArray(metadata?.retrievedContext) ? metadata.retrievedContext : [];
}
